import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { OrderSearchRequestBody, OrderSearchResponse } from "./types";

export class OrderSearchAPI extends BaseAPI<
  OrderSearchRequestBody,
  OrderSearchResponse
> {
  protected route = ApiRoutes.order.search;
  protected method = RequestMethod.POST;
}
